export default __webpack_public_path__ + "static/media/closed-captioning.9b23043f.svg";